module.exports = __webpack_public_path__ + "media/images/get_my_apps_image-e90e324890aec9fbe002497eed9f14af.png";